<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { onMounted } from 'vue'
import { useSitesStore } from './stores/sites'

export default {
  name: 'App',
  setup() {
    const sitesStore = useSitesStore()

    onMounted(() => {
      // Initialize authentication state from localStorage
      sitesStore.initAuth()
    })

    return {}
  }
}
</script>

<style>
#app {
  font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>